export class Setting {
  value: {
    hillerCompanyId: number;
    hillerWorkforceTrainingMaxHours: number;
    housingAllowanceStates: string;
    toolsStates: string;
    workforceTraningStates: string;
  };
}
